// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Japan */
const JP = /^(?:[6-9]0[1-9]\d{7})$/;

export default JP;
